import React from "react"
import { Col, Modal, ModalFooter, ModalBody, ModalHeader } from "reactstrap"
import ViewInput from "./ViewInput"
import { groupDataByValue } from "helpers/util"
import moment from "moment"

const ViewReports = ({
  isOpen,
  toggle,
  handlecancel,
  handleAccordion,
  sethandleAccordion,
  SelectedDataReports,
  HoursReportPage,
  selectedclientId,
  selectedprojectId,
  activeReportStatus,
}) => {
  const groupByKey = "projectName"

  const filterClient =
    selectedclientId?.label === "All" || selectedclientId == undefined
      ? SelectedDataReports?.projectSummaryList
      : SelectedDataReports?.projectSummaryList
          ?.map(el => ({
            ...el,
            clientId: el?.tasks?.[0]?.clientId,
            userName: el?.tasks?.[0]?.userName,
          }))
          .filter(el => el.clientId === selectedclientId?.id)

  const groupedDataScreens = groupDataByValue(
    selectedprojectId?.label === "All" || selectedprojectId == undefined
      ? filterClient
      : filterClient
          ?.map(el => el)
          .filter(el => el.projectID === selectedprojectId?.id) || [],
    groupByKey
  )

  const groupedScreens = Object?.entries(groupedDataScreens).map(
    ([key, value], index) => ({
      key,
      index: index,
      data: value[0]?.tasks,
      date: moment(value[0]?.tasks?.[0].timeSummaryDate).format("YYYY-MM-DD"),
    })
  )

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal modal-xl"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={handlecancel}>
          <div className="d-flex">
            <div>View Report</div>
          </div>
        </ModalHeader>
        <ModalBody className="selectAllBody">
          {activeReportStatus?.id == 2 && (
            <div className="text-center">
              Project:{"   "}
              <strong>{SelectedDataReports?.[0]?.tasks[0]?.displayName}</strong>
            </div>
          )}
          {!HoursReportPage ? (
            (SelectedDataReports || []).map((item, idx) => (
              <React.Fragment
                key={`${item.projectId}_${item.clientId}_${item.accountId}_${idx}`}
              >
                {SelectedDataReports?.length === undefined ||
                SelectedDataReports?.length === 0 ? (
                  <div className="text-center">No Report Found.</div>
                ) : (
                  <>
                    <ViewInput
                      item={item?.tasks}
                      sethandleAccordion={sethandleAccordion}
                      handleAccordion={handleAccordion}
                      keyId={idx}
                      HoursReportPage={false}
                      username={SelectedDataReports?.userId == 0 ? true : false}
                      selectedprojectId={selectedprojectId}
                      activeReportStatus={activeReportStatus}
                    />
                  </>
                )}
              </React.Fragment>
            ))
          ) : (
            <>
              {SelectedDataReports ? (
                <>
                  <div className="mb-2 text-center">
                    <strong>Date:</strong> {groupedScreens?.[0]?.date}
                  </div>
                  {groupedScreens.map(({ date, data }, index) => (
                    <div key={index}>
                      <ViewInput
                        item={data}
                        sethandleAccordion={sethandleAccordion}
                        handleAccordion={handleAccordion}
                        keyId={date}
                        HoursReportPage={true}
                        activeReportStatus={activeReportStatus}
                      />
                    </div>
                  ))}
                </>
              ) : (
                <div className="text-center">No Report Found.</div>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter className="mobile_align_approve">
          <Col>
            <div className="text-end p-0">
              <button
                type="button"
                color="primary"
                className="btn btn-secondary align_width-team"
                onClick={handlecancel}
              >
                Cancel
              </button>
            </div>
          </Col>
        </ModalFooter>
      </div>
    </Modal>
  )
}

export default ViewReports
